export enum App {
  Scout,
  Match,
  Mobilytics,
  Healthcare,
  Brandalicious,
  MyReports,      // List of Reports
  Reports,        // A Report
  Explore,
  Factor,
  BuxtonUniversity,
  UserSettings,
  MobilyticsPro,
  Iq,
  Alert,
  Analyze,
  Persona,
}
